<template>
  <base-modal overlay-class="mini_games_modal">
    <div class="modal__body">
      <h1>
        {{ getTranslations.modal_pre_lantern_game_title_pt1 }}<br>
        {{ getTranslations.modal_pre_lantern_game_title_pt2 }}
      </h1>

      <p>{{ getTranslations.modal_pre_lantern_game_subtitle }}</p>

      <base-image src="/static/images/lanterns/lantern_sign.svg" image-class="modal_icon_main" alt="lantern icon" />
    </div>

    <div class="modal__footer">
      <p>
        {{ getTranslations.modal_pre_lantern_game_description_pt1 }}
        <span>{{ timerForLanternGame }} {{ getTranslations.modal_pre_lantern_game_description_pt2 }}</span>
        {{ getTranslations.modal_pre_lantern_game_description_pt3 }}
      </p>

      <p>{{ getTranslations.modal_pre_lantern_game_description_pt4 }}</p>

      <a
        v-if="canPlay"
        href="#"
        class="ti_btn--main"
        @click.prevent="$emit('play:lantern')"
      >
        {{ getTranslations.modal_pre_lantern_game_button_proceed }}
      </a>

      <div
        v-else
        class="error_text"
        style="margin-bottom: 16px"
      >
        {{ getTranslations.modal_pre_lantern_game_error_already_played }}
      </div>
    </div>
  </base-modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BaseModal from '../BaseModal.vue';
import BaseImage from '../../image/BaseImage.vue';

export default {
  name: 'PreLanternGameModal',
  emits: ['play:lantern'],
  components: {
    BaseModal,
    BaseImage,
  },
  props: {
    canPlay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('common', [
      'timerForLanternGame',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/modal/game/PreLanternGameModal.vue